jQuery(document).ready(function ($) {

    $('.bloc_paraphotos').each(function () {
        const $block = $(this)
        const items = $block.find('.photos .slider > figure').get()
        if (!items.length) return

        gsap.from(items, {
            y: 200,
            ease: "power3.out",
            stagger: 0.3,
            scrollTrigger: {
                trigger: $block[0],
                start: 'top 90%',
                end: 'bottom 98%',
                scrub: .8
            }
        })
    })
})
